const middleware = {}

middleware['force-server-render'] = require('../middleware/force-server-render.js')
middleware['force-server-render'] = middleware['force-server-render'].default || middleware['force-server-render']

middleware['rbac'] = require('../middleware/rbac.js')
middleware['rbac'] = middleware['rbac'].default || middleware['rbac']

export default middleware
